var MetricsAuthoringScenarioLoggingNames = /* @__PURE__ */ ((MetricsAuthoringScenarioLoggingNames2) => {
  MetricsAuthoringScenarioLoggingNames2["MergeDraft"] = "MergeDraft";
  MetricsAuthoringScenarioLoggingNames2["ValidateDraft"] = "ValidateDraft";
  MetricsAuthoringScenarioLoggingNames2["Create_ComputationTemplateInstance"] = "Create_ComputationTemplateInstance";
  MetricsAuthoringScenarioLoggingNames2["PreviewScorecard_PublishDraft"] = "PreviewScorecard_PublishDraft";
  MetricsAuthoringScenarioLoggingNames2["PreviewScorecard"] = "PreviewScorecard";
  MetricsAuthoringScenarioLoggingNames2["PreviewScorecardInput"] = "PreviewScorecardInput";
  MetricsAuthoringScenarioLoggingNames2["PreviewScorecardCompilePublish"] = "PreviewScorecardCompilePublish";
  MetricsAuthoringScenarioLoggingNames2["PreviewScorecard_SelectExperimentStep"] = "PreviewScorecard_SelectExperimentStep";
  MetricsAuthoringScenarioLoggingNames2["PreviewScorecard_CreatePreviewAnalysis"] = "PreviewScorecard_CreatePreviewAnalysis";
  MetricsAuthoringScenarioLoggingNames2["CreateMetricSetInstance"] = "CreateMetricSetInstance";
  MetricsAuthoringScenarioLoggingNames2["MetricWizard_Authoring"] = "MetricWizard_Authoring";
  MetricsAuthoringScenarioLoggingNames2["MetricWizard_CustomDimension"] = "MetricWizard_CustomDimension";
  MetricsAuthoringScenarioLoggingNames2["CreateCustomColumn"] = "CreateCustomColumn";
  MetricsAuthoringScenarioLoggingNames2["QuickValidation_Compilation"] = "QuickValidation_Compilation";
  MetricsAuthoringScenarioLoggingNames2["QuickValidation_ValidationPreview"] = "QuickValidation_ValidationPreview";
  return MetricsAuthoringScenarioLoggingNames2;
})(MetricsAuthoringScenarioLoggingNames || {});
export {
  MetricsAuthoringScenarioLoggingNames
};
//# sourceMappingURL=MetricsAuthoringScenarioLoggingNames.js.map
